import { Tooltip } from 'react-tooltip'
import { useState } from "react"

import { EventEmitter, eventTypes, events } from "../app/event-emitter";
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { animationPositionSelector, configuratorActions } from '../app/configurator-slice';
import { showPopup } from "../app/popup-slice";
import { useMessages2 } from '../hooks/useLanguage';
import { catalogSelector } from '../app/configurator-selectors';

import plusIcon from '../img/plus-solid.svg'
import minusIcon from '../img/minus-solid.svg'
import cameraIcon from '../img/camera-solid.svg'
import styles from "./view-controls.module.css"

const ViewControl = ({ resetCameraBehaviour, show2D, legendOptions }: {
    resetCameraBehaviour: 'fit' | 'initial'
    show2D: boolean
    legendOptions?: any
}) => {

    const animationPosition = useAppSelector(animationPositionSelector) ?? 0;
    const scene = useAppSelector(state => state.configurator.scene);
    const { initial } = useAppSelector(catalogSelector);

    const { messages } = useMessages2();
    const dispatch = useAppDispatch();
    const [is2D, setIs2D] = useState(false);

    const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const asNumber = Number(event.target.value);
        dispatch(configuratorActions.setAnimationPosition(asNumber));
        window.requestAnimationFrame(() => {
            EventEmitter.dispatch(eventTypes.VIEW_CONTROLS, events.SET_ANIMATION_EVENT, {
                sceneId: scene,
                percentage: asNumber
            });
        });
    };
 
    const sendEventValue = (event: string) => {
        EventEmitter.dispatch(eventTypes.VIEW_CONTROLS, event)
    };
    const showLegendDialog = () => {
        dispatch(showPopup({dialog: "infoLegend", popupContent: legendOptions}))
    }


    const resetCamera = () => {
        if(resetCameraBehaviour === 'fit') {
            EventEmitter.dispatch(eventTypes.VIEW_CONTROLS, events.FIT_CONTENT_EVENT, scene);
        } else if(initial?.camera) {
            EventEmitter.dispatch(eventTypes.VIEW_CONTROLS, events.SET_CAMERA_EVENT, { camera: initial.camera, inmediate: false });
        }
    }

    const handle2D = () => {
        setIs2D(!is2D);
        if(is2D) {
            EventEmitter.dispatch(
                eventTypes.VIEW_CONTROLS,
                events.SWITCH_CAMERA_EVENT,
                { type: '3d', scene }
            );
        } else {
            EventEmitter.dispatch(
                eventTypes.VIEW_CONTROLS,
                events.SWITCH_CAMERA_EVENT,
                { type: '2d', scene }
            );
        }
    }

    
    return (
        <div className={styles.viewControlContainers}>
            <div className={styles.viewControl}>

                <Tooltip anchorSelect="#vczoomout" content={messages?.Legende_zoom_uit ?? ''} />
                <button id="vczoomout" className={styles.roundButton} onClick={() => sendEventValue(events.ZOOM_OUT_EVENT)}>
                    <img src={minusIcon}/>
                </button>
                
                <Tooltip anchorSelect="#vczoomin" content={messages?.Legende_zoom_in ?? ''} />
                <button id="vczoomin" className={styles.roundButton} onClick={() => sendEventValue(events.ZOOM_IN_EVENT)}>
                    <img src={plusIcon}/>
                </button>
                
                <Tooltip anchorSelect="#vcanimation" content={messages?.Legende_schuifbalk ?? ''} offset={16}/>
                <input id="vcanimation"
                    type="range"
                    className={styles.slider}
                    min={0}
                    max={100}
                    value={animationPosition}
                    onChange={handleSliderChange}
                    step={0.01}
                />   

                <Tooltip anchorSelect="#vcresetview" content={messages?.Legende_start_position ?? ''} offset={16}/>
                <button id="vcresetview" className={styles.roundButton} onClick={resetCamera}>
                    <img src={cameraIcon}/>
                </button>

                <Tooltip anchorSelect="#vcshowlegend" content={messages?.Legende_info ?? ''}/>
                <button id="vcshowlegend" className={styles.roundButton} onClick={showLegendDialog}>
                    <span>i</span>
                </button>

                { /*
                <Tooltip anchorSelect="#vcar" content={messages?.Legende_start_position ?? ''}/>
                <button id="vcar" className={styles.roundButton} onClick={() => sendEventValue(events.AUGMENTED_REALITY_EVENT)}>
                    <span>AR</span>
                </button> 
                */ }
                
                { show2D ?
                    <>
                        <Tooltip anchorSelect="#vc2d" content={messages?.Legende_2D ?? ''}/>
                        <button id="vc2d" className={styles.roundButton} onClick={handle2D}>
                            <span>{is2D ? '3D' : '2D'}</span>
                        </button>
                    </>
                    : null }
            </div> 
        </div>   
    )}

export default ViewControl